import * as v from 'valibot';

const IsoDate = v.pipe(v.string(), v.isoTimestamp());

/* Product Class options */
export const productClassApiSchema = v.object({
  codeDesc: v.string(),
  codeId: v.string(),
  creationTime: IsoDate,
  creatorUserId: v.number(),
  id: v.number(),
  lastModificationTime: v.nullable(IsoDate),
  lastModifierUserId: v.nullable(v.number()),
  locked: v.nullable(v.boolean()),
  lookupCodeType: v.string(),
  standardCode: v.nullable(v.string()),
  status: v.nullable(v.string()),
  string1: v.nullable(v.string()),
  string2: v.nullable(v.string()),
  string3: v.nullable(v.string()),
  value1: v.nullable(v.unknown()),
  value2: v.nullable(v.unknown()),
  value3: v.nullable(v.unknown()),
});

export const productClassListApiSchema = v.array(productClassApiSchema);

export type ProductClassListApi = v.InferOutput<typeof productClassListApiSchema>;

/* Products Summary */
export const productsSummaryApiSchema = v.object({
  billQty: v.number(),
  cube: v.number(),
  dimUnitOfMeasure: v.string(),
  height: v.number(),
  length: v.number(),
  packageBilledQuantityUnitOfMeasure: v.string(),
  totalChargeableWeight: v.number(),
  weightUnitOfMeasure: v.string(),
  width: v.number(),
});

export type ProductsSummaryApi = v.InferOutput<typeof productsSummaryApiSchema>;
